// Add Authorization header to each request

angular.module('homebot.services').service('AuthHeaderInterceptor', ['SessionService', function(SessionService) {
  return {
    request(config) {
      let authHeader = SessionService.getAuthHeader();

      if (authHeader)
          config.headers.Authorization = authHeader;

      return config;
    },
  };
}]);
